// src/layout/NotificationsMenu.jsx
//
// Topbar notifications bell. There's no notifications backend today, so
// this intentionally shows a clean empty state rather than fabricated
// events — unlike a placeholder org/project name, invented notification
// text ("X passed go-live gate") would read as a real event to a real
// user. Swap `hasUnread`/the empty state for real data once a
// notifications endpoint exists.

import PropTypes from "prop-types";
import { Bell } from "lucide-react";

export default function NotificationsMenu({ open, onToggle }) {
  const hasUnread = false;

  return (
    <div style={{ position: "relative" }}>
      <button type="button" className="orion-iconbtn orion-sq-btn-plain" onClick={onToggle} title="Notifications">
        <Bell size={18} />
        {hasUnread && <span className="orion-badge-dot" />}
      </button>

      {open && (
        <div className="orion-dropmenu" style={{ width: 300, right: 0, left: "auto", top: 50 }}>
          <div className="orion-drop-hd" style={{ fontWeight: 700, fontSize: 13, textTransform: "none", letterSpacing: 0, borderBottom: "1px solid var(--jade-neutral-200)", paddingBottom: 11 }}>
            Notifications
          </div>
          <div className="orion-notif-empty">You&rsquo;re all caught up.</div>
        </div>
      )}
    </div>
  );
}
NotificationsMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
